import { UseFormReturn } from 'react-hook-form';

import { AssetAllocation } from '@ndvr/portfolio-api';

import { calculateTotalWeight } from '../../shared-utils';
import { ModelFormValues } from './model-form-schema';

export function useModelStrategyElements(form: UseFormReturn<ModelFormValues>) {
    const elements = form.watch('strategyElements');

    const remainingWeight = () => {
        const totalWeight = calculateTotalWeight(elements);
        return Math.round(Math.max(0, 100 - totalWeight) * 100) / 100;
    };

    const addExisting = (strategyGUID: string) => {
        form.setValue('strategyElements', [
            ...elements,
            { mode: 'existing', weight: remainingWeight().toString(), existingStrategyGUID: strategyGUID },
        ]);
    };

    const commitNew = (name: string, assetAllocations: AssetAllocation[]) => {
        form.setValue('strategyElements', [
            ...elements,
            {
                mode: 'new',
                weight: remainingWeight().toString(),
                newStrategyName: name,
                newStrategyAssetAllocations: assetAllocations,
            },
        ]);
    };

    const removeElement = (index: number) => {
        form.setValue(
            'strategyElements',
            elements.filter((_, i) => i !== index),
        );
    };

    const updateWeight = (index: number, weight: string) => {
        form.setValue(
            'strategyElements',
            elements.map((el, i) => (i === index ? { ...el, weight } : el)),
        );
    };

    const evenSplit = () => {
        const n = elements.length;
        if (n === 0) return;
        const each = Math.floor(100 / n);
        form.setValue(
            'strategyElements',
            elements.map((el, i) => ({ ...el, weight: (i === 0 ? 100 - each * (n - 1) : each).toString() })),
        );
    };

    return {
        elements,
        addExisting,
        commitNew,
        removeElement,
        updateWeight,
        evenSplit,
    };
}
